/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>

(function() {
  var ns = nspace("ccc.indicatorSelection");

  ns.IndicatorSelectionModel = Backbone.Model.extend({
    defaults: {
      currentTab: "any",
      currentTabId: 0,
      selectedCategories: {}
    }
  });
})(jQuery);
